import React, { useContext } from 'react';
import { FormContext } from 'contexts/FormContext';
import {
  ApplicationName,
  FormNavigation,
  ControlInputGroup
} from 'components/CASAForm';
import {
  AuCallout,
  AuFormItemWrapper,
  AuDirectionLink
} from 'components/DTA';
import { IDENTITY_TYPES } from 'arnConstants';
import { ArnApplicationDvsMethodFormData } from 'types/forms/arnApplicationTypes';
import { useFormikContext } from 'formik';
import { isEmpty } from 'lodash';

const IdentityVerification: React.FC = (props: any) => {
  const { validateForm } = useFormikContext<ArnApplicationDvsMethodFormData>();
  const { handleBack, setFormAlert, openStepById, setOnChangeValidation } = useContext(FormContext);
  const { nextStep } = props;

  const handleNext = async () => {
    const validationErrors = await validateForm();
    if (!validationErrors || isEmpty(validationErrors)) {
      setFormAlert(null);
      setOnChangeValidation(false);
      openStepById(nextStep);
    }
    else {
      setOnChangeValidation(true);
    }
  };

  const manualPOIVerification = (e) => {
    e.preventDefault();
    openStepById('ManualPOIInformation');
  };

  return (
    <>
      <ApplicationName name='Identity verification' />
      <AuDirectionLink
        onClick={handleBack}
        text="Back"
        direction="left" />
      <AuFormItemWrapper>
        <AuCallout >
          <p>You must verify your identity to complete your ARN application.</p>
          <p>Most identity documents can be verified online and this process should only take a few minutes.</p>
        </AuCallout>
      </AuFormItemWrapper>
      {/* TODO: option values might change later */}
      <ControlInputGroup
        name='identityType'
        label='Please choose one of the following identification types to continue:'
        type='radio'
        block
        options={[
          {
            label: 'Australian passport',
            hintText: '(current or expired within three years but not cancelled)',
            value: IDENTITY_TYPES.AU_PASSPORT
          },
          {
            label: 'Australian birth certificate',
            hintText: '(full certificate and not an extract)',
            value: IDENTITY_TYPES.AU_BIRTH_CERTIFICATE
          },
          {
            label: 'Australian citizenship certificate',
            hintText: '(full certificate and not an extract)',
            value: IDENTITY_TYPES.AU_CITIZENSHIP_CERTIFICATE
          },
          {
            label: 'Foreign passport',
            hintText: '(current and not expired)',
            value: IDENTITY_TYPES.FORIGN_PASSPORT
          },
          {
            label: 'ImmiCard',
            hintText: '(Evidence of Immigration Status; issued to some temporary visa holders in Australia)',
            value: IDENTITY_TYPES.IMMI_CARD
          }
        ]}
      />
      <a href="" target="_blank" rel='noreferrer' onClick={manualPOIVerification}>I don&apos;t have any of these documents</a>
      <FormNavigation
        nextButtonText='Next'
        onNextAction={handleNext}
        hidePrevious
        showSaveAndExit={false} />
    </>
  );
};

export default IdentityVerification;